import PartnerAdminInfo from "./PartnerAdminInfo";
export default PartnerAdminInfo;